import * as amplitude from '@amplitude/analytics-browser'

class AmplitudeService {
  private initialized = false

  init(apiKey: string) {
    if (this.initialized) {
      console.warn('Amplitude is already initialized')
      return
    }

    amplitude.init(apiKey, {
      autocapture: false,
      serverZone: 'EU',
    })
    this.initialized = true
  }

  isInitialized() {
    return this.initialized
  }

  /**
   * Event tracking
   * @param eventName - Event Name
   * @param eventProperties - Event properties (optionnal)
   */
  track(
    eventName: string,
    eventProperties?: Record<string, unknown>,
  ): amplitude.Types.AmplitudeReturn<amplitude.Types.Result> | undefined {
    if (!this.initialized) {
      console.warn('Amplitude not initialized. Call init() first.')
      return
    }

    return amplitude.track(eventName, eventProperties)
  }

  /**
   * User tagging
   * @param userId
   */
  setUserId(userId: string | undefined) {
    if (!this.initialized) {
      console.warn('Amplitude not initialized. Call init() first.')
      return
    }

    amplitude.setUserId(userId)
  }

  /**
   * Defines user properties
   * @param properties - user properties
   */
  setUserProperties(properties: Record<string, any>) {
    if (!this.initialized) {
      console.warn('Amplitude not initialized. Call init() first.')
      return
    }

    const identifyEvent = new amplitude.Identify()

    Object.entries(properties).forEach(([key, value]) => {
      identifyEvent.set(key, value)
    })

    amplitude.identify(identifyEvent)
  }

  /**
   * Reset users (after logout)
   */
  reset() {
    if (!this.initialized) {
      console.warn('Amplitude not initialized. Call init() first.')
      return
    }

    amplitude.reset()
  }
}

export const amplitudeService = new AmplitudeService()
